import * as React from 'react';

import { Icon } from './icon';
import { cn } from '@/new/lib/utils';

export interface SearchInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'default' | 'sm';
}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, size = 'default', ...props }, ref) => {
    const isSm = size === 'sm';
    return (
      <div
        className={cn(
          'flex items-center rounded-lg border border-gray-300 bg-white ring-offset-2 transition-colors duration-150 focus-within:ring focus-within:ring-teal-500',
          isSm && 'rounded-md',
          className,
        )}
      >
        <Icon className={cn('lucide--search mx-2.5 mr-2 text-base text-gray-400', isSm && 'mx-2 mr-1.5 text-xs')} />
        <input
          ref={ref}
          type="text"
          className={cn(
            'w-full py-1.5 text-sm text-gray-900 outline-none placeholder:text-gray-400 focus:outline-none',
            isSm && 'py-1 text-[13px]',
          )}
          {...props}
        />
      </div>
    );
  },
);
SearchInput.displayName = 'SearchInput';
